import React from 'react'

import icons from './providerDetailsIcons.json'

// Artwork and scaling from the supplied FinderCONNECT exports.
export default function DetailIcon({ name, size = 24 }) {
  const icon = icons[name]
  const scale = Math.min(size / icon.w, size / icon.h)
  return (
    <span
      className="details-icon"
      aria-hidden="true"
      style={{ width: size, height: size }}
    >
      <svg
        width={icon.w * scale}
        height={icon.h * scale}
        viewBox={icon.viewBox}
        dangerouslySetInnerHTML={{ __html: icon.body }}
      />
    </span>
  )
}
